module.exports = __webpack_public_path__ + "media/images/icons/helpline-phone-c3de1d5e6a33fd9da0dd72706dae7e28.svg";